export enum REASON_FOR_OPEN {
  UNHAPPY = 'UNHAPPY',
  ORGANIZING = 'ORGANIZING',
  ONE_PLACE = 'ONE_PLACE',
  JUST_STARTED = 'JUST_STARTED',
  LOAN = 'LOAN',
  OTHER = 'OTHER',
}

export const REASON_FOR_OPEN_ARRAY = Object.values(REASON_FOR_OPEN);
